// extracted by mini-css-extract-plugin
export default {"logoWrapper":"Logo_logoWrapper__53hdQ","logo":"Logo_logo__6yrBi","logoLabel":"Logo_logoLabel__SKeV+"};